// **Welcome!**
//This file is your location to update all of the text, icon, and image variables throughout the application.  Even if you love the current defaults you will need to update the brand name throughout this file as it is hard coded in some places.

//If you would like to rename any pages, simply change the name of the page folder and component, but don't forget to update the routes.js file with the new path, name and icon you wish to use (these are utilized in the nav menus). To add pages, create a new folder and again, be sure to add it to the routes.js file.

//logos
import appleLogo from '../assets/icons/logos/apple_logo.png';
import brandIcon from '../assets/icons/logos/give-icon.svg';
import brandLogo from '../assets/icons/logos/giveLogo.svg';
import linuxLogo from '../assets/icons/logos/linux_logo.png';
import windowsLogo from '../assets/icons/logos/window_logo.png';

//images
import benefitImage from '../assets/images/createAccountImage.png';
import emailSentImage from '../assets/images/verify-email.svg';
import verifyImage from '../assets/images/verify-email.svg';
import imageLockInPrice from '../assets/images/LoadingScreenGraphic.png';
import imageProcessOrder from '../assets/images/ProcessOrder.png';
import imageSubmitOrder from '../assets/images/enter-passcode.png';
import mintRewardsImage from '../assets/images/MintRewards.svg';
import mfaImage1 from '../assets/images/2fa-1.png';
import mfaImage2 from '../assets/images/2fa-2.png';
import mfaImage3 from '../assets/images/2fa-3.png';
import mfaImageDisable from '../assets/images/mfaDisable.png';
import mfaImageEnable from '../assets/images/mfaEnable.png';
import pageNotFoundImage from '../assets/images/page-not-found.png';
import sendConfirmationImg from '../assets/images/SendConfirmation.svg';
import serverErrorImage from '../assets/images/server-error.png';
import setupProcessingImg from '../../public/setupProcessingImage.png';

//icons
import circleClock from '../assets/icons/nerdCoreKit/circle-clock.svg';
import confirmCircleCheck from '../assets/icons/nerdCoreKit/circle-check-regular.svg';
import downArrow from '../assets/icons/fontawesome/angle-down-solid.svg';
import greenDot from '../assets/icons/nerdCoreKit/circle-solid-green.svg';
import leftArrow from '../assets/icons/fontawesome/caret-left-solid.svg';
import orangeDot from '../assets/icons/nerdCoreKit/circle-solid-orange.svg';
import redDot from '../assets/icons/nerdCoreKit/circle-solid-red.svg';
import rightArrow from '../assets/icons/fontawesome/caret-right-solid.svg';
import upArrow from '../assets/icons/fontawesome/angle-up-solid.svg';
import warningIcon from '../assets/icons/nerdCoreKit/circle-line-solid.svg';

const brandName = 'Give';
const brandCoin = 'GIVE';
const staticSite = 'https://giveblockchain.io/';
const BRAND_NAME = 'Give';

export const brand = {
  // Temporary brand-token ERC data
  brandTokenERC: {
    coinSymbol: `GIVE`,
    coinAmt: null,
    coinLogo:
      // ! Add your brand base64 image here
      'data:image/png;base64,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',
    coinName: 'Give',
    usd: null,
    walletId: '',
    valid: false,
    hasError: false,
  },
  // Brand Info
  brandName: 'Give',
  coin: 'GIVE',
  logo: brandLogo.src,
  icon: brandIcon.src,
  loggedOutHomeRoute: '/', //clicking 'home' like the brand logo - where do you want to take the user, you can also put your static site url here
  loggedInHomeRoute: '/dashboard/nodes',
  blockFabricEnabled: true, //brand is on the chain ledger
  chainLedgerAPI: '', //http://rpc.testnet.galvan.blockfabric.net belongs to Galvan and is only an example of what the url will look like MUST BE UPDATED TO YOUR BRAND URL

  customerSupportLink: 'http://localhost:3000/support',
  //this key must match what your static marketing site sets in the cookies preferences center
  cookiesPreferencesKey: 'NerdCookiesPreferences',
  cookiesDomain: '.nerdunited.net',
  //Styling Info
  theme: {
    brandName: BRAND_NAME,
    primaryColor: '#FAD446', /* #d51e3e */
    secondaryColor: 'lightgray',
  },
  errorMessages: {
    genericError: 'Something has gone wrong, please try again later.',
    inputValidationFields: {
      name: 'Improperly formatted name',
      email: 'Enter a valid email (john@example.com)',
      password: 'Password does not meet the character requirement',
      confirmPassword: 'Passwords do not match',
      checkbox: 'You must be over 18 to sign up.',
      phone: 'Improperly formatted phone number',
    },

    //Login
    disabledAccount:
      'Your account has been temporarily disabled due to too many login attempts. Please reset your password or try again later.',
    emailNotVerifiedText: 'Email not verified',
    emailNotVerifiedLinkText: 'send confirmation again?',

    //Signup
    emailInUse: 'That email is already in use, please try another or login.',

    //Reset Password
    linkUsed:
      'That reset link has already been used. We will send a new reset link to your email',

    //Dashboard
    loadingError: 'Error Loading Wallet Data - Please Refresh the Page',
    sendCoinError:
      'There was a problem with the transaction. Please check the Send To Address and try again.',
    mintFundsError:
      'Sorry, you do not currently have enough ETH to mint. Add more ETH and try again.',
    mintError:
      'Something went wrong and we are not able to mint your rewards. Please try again later.',
    //Purchase
    getInvoice: 'Experiencing difficulties setting up your order. Please try again later',
    //Checkout steps - purchase
    processPayment:
      ' Something went wrong and we were not able to process your payment. Please try again.',
    //Rewards
    getRewardsError:
      'System error. The boxes highlighted in red cannot be displayed at this time.',
    //ManageAccount/Profile
    updateProfileError: 'Something went wrong, please try updating your profile again.',
    birthDateError: 'Invalid Date Format, please use MM/DD/YYYY',
    birthDateAge: 'Please check the year',
  },
  pages: {
    //Any default text can be overwritten by populating the value or changing it from undefined
    login: {
      //see login page to comment in the brand icon prop if you want it to display on the login form
      welcomeText: 'Welcome!',
      subText: 'Make an impact by encouraging transparency and a life of giving',
      createAccountButtonText: 'Create an Account',
      supportText: 'Need Help?',
      supportLinkText: 'Contact Support',

      //Forgot Password Modal
      forgotHeadingText: '',
      forgotErrorIcon: warningIcon.src,

      //Email Sent
      sentHeadingText: '',
      sentSubText: '',
      sentImage: emailSentImage.src,

      //2FA enabled user code verification modal
      mfaModal: {
        header: 'Enter Two-Factor Authentication',
        subText: 'Enter the 6-digit authentication code below we sent to ', //phone number populated dynamically in the page
        supportText: (
          <>
            If you have issues with receiving a code on your phone and are unable to
            proceed, please contact{' '}
            <a href={staticSite} style={{ textDecoration: 'underline' }}>
              {brandName} customer service.
            </a>
          </>
        ),
        buttonText: 'Cancel Sign In',
        invalidCodeError: 'Wrong SMS code. Try again.',
      },
      sessionExpiredModal: {
        image: circleClock.src,
        title: 'Your session has expired due to inactivity.',
      },
    },
    signup: {
      //SignupForm
      //********* THIS text has a hard coded brand name, PLEASE UPDATE IT!! *********/
      callToActionText: `Join over 100,000 supporters already using ${BRAND_NAME}`,
      //true shows full name field, false shows first/last name fields
      showOnlyFullName: false,
      userHasAccountText: 'Already have an account?',
      userHasAccountLinkText: 'Login here',

      //Benefit
      benefitImage: benefitImage.src,
      headingText: `Purchase nodes. Earn rewards. Be the blockchain.`,
      bodyText:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    },
    resetPassword: {
      //ResetPasswordForm
      headingText: '',
      //Password Changed
      buttonText: 'Log In',
      subText: '',
      image: "data:image/svg+xml,%3csvg id='Layer_2' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1210.79 1316.64'%3e%3cdefs%3e%3cstyle%3e.cls-1%7bopacity:.1;%7d.cls-2%7bopacity:.1;%7d.cls-3,.cls-4%7bfill:%23fff;%7d.cls-5,.cls-6%7bfill:%23326260;%7d.cls-7%7bfill:%23323744;%7d.cls-8%7bfill:%23a8a8a8;%7d.cls-9%7bfill:%2389a5af;%7d.cls-10%7bfill:%235ba8a1;%7d.cls-11%7bfill:%23264946;%7d.cls-4%7bopacity:.2;%7d.cls-6%7bopacity:.3;%7d%3c/style%3e%3c/defs%3e%3cg id='Layer_1-2'%3e%3cg%3e%3cpath class='cls-6' d='M597.57,1315.4c-6.06-.96-150.14-24.52-295.66-112.12-86.94-52.33-156.46-116.76-206.64-191.48C32.05,917.66,0,807.82,0,685.32V181.06c0-14.62,4.08-36.76,23.51-59.16,11.27-12.99,26.24-24.6,45.77-35.49,32.01-17.85,76.38-33.54,131.88-46.64C309.7,14.16,453.26,.04,605.38,0c152.16,.04,295.71,14.16,404.24,39.77,55.5,13.1,99.88,28.79,131.88,46.64,19.53,10.89,34.5,22.5,45.77,35.49,19.43,22.4,23.51,44.54,23.51,59.16v504.26c0,122.5-32.05,232.34-95.27,326.48-50.18,74.72-119.7,139.15-206.64,191.48-145.52,87.6-289.6,111.16-295.66,112.12l-7.82,1.24-7.82-1.24Z'/%3e%3cpath class='cls-10' d='M1160.78,181.06v504.26c0,492.74-555.39,580.7-555.39,580.7,0,0-369.6-58.53-505.78-347.6-10.45-22.18-19.52-45.71-26.95-70.68-14.44-48.53-22.66-102.48-22.66-162.42V181.06c0-72.33,248.61-130.99,555.39-131.06,38.33,0,75.75,.93,111.89,2.68,51.32,2.49,100.07,6.64,145.16,12.21,177.35,21.9,298.34,65.71,298.34,116.17Z'/%3e%3cpath class='cls-4' d='M717.96,85.04c0,383.45-279.12,701.71-645.29,762.7-14.44-48.53-22.66-102.48-22.66-162.42V181.06c0-72.33,248.61-130.99,555.39-131.06,38.33,0,75.75,.93,111.89,2.68,.45,10.74,.67,21.52,.67,32.36Z'/%3e%3crect class='cls-1' x='165.52' y='752.76' width='879.75' height='220.73' rx='110.36' ry='110.36'/%3e%3crect class='cls-3' x='165.52' y='735.09' width='879.75' height='220.73' rx='110.36' ry='110.36'/%3e%3cg%3e%3cpath class='cls-8' d='M866.56,444.5v256.87c0,40.45-32.79,73.24-73.24,73.24H417.5c-40.45,0-73.27-32.79-73.27-73.24V444.5c0-4.29,.38-8.53,1.1-12.62,5.98-34.44,36.01-60.62,72.17-60.62h375.82c40.45,0,73.24,32.79,73.24,73.24Z'/%3e%3cpath class='cls-11' d='M866.56,444.5v256.87c0,40.45-32.79,73.24-73.24,73.24H417.5c-40.45,0-73.27-32.79-73.27-73.24V444.5c0-4.29,.38-8.53,1.1-12.62,5.98-34.44,36.01-60.62,72.17-60.62h375.82c40.45,0,73.24,32.79,73.24,73.24Z'/%3e%3cpath class='cls-9' d='M797.18,284.2c-13.17-93.44-93.67-165.52-190.68-165.52s-177.48,72.08-190.65,165.52c-1.28,8.85-1.92,17.88-1.92,27.07v174.23c0,28.26,22.98,51.28,51.25,51.28h282.64c28.29,0,51.28-23.01,51.28-51.28v-174.23c0-9.2-.64-18.22-1.92-27.07Zm-54.06,196.6H469.88v-169.53c0-9.26,.93-18.31,2.7-27.07,12.59-62.45,67.85-109.57,133.92-109.57s121.33,47.13,133.92,109.57c1.77,8.76,2.7,17.82,2.7,27.07v169.53Z'/%3e%3cg class='cls-2'%3e%3cpath d='M469.88,354.84v16.42h-55.95v-18.03c19.54,.88,38.18,1.41,55.95,1.61Z'/%3e%3c/g%3e%3cg class='cls-2'%3e%3cpath d='M799.09,311.28v59.98h-55.98v-51.74c24.32-9.16,42.07-19.02,54.95-28.15,.68,6.54,1.03,13.17,1.03,19.91Z'/%3e%3c/g%3e%3cpath class='cls-5' d='M866.56,444.5v205.65c-5.98,34.44-35.98,60.62-72.14,60.62H418.6c-40.45,0-73.27-32.79-73.27-73.24v-205.65c5.98-34.44,36.01-60.62,72.17-60.62h375.82c40.45,0,73.24,32.79,73.24,73.24Z'/%3e%3cg%3e%3cpath class='cls-7' d='M653.4,472.03c0,9.25-2.61,17.88-7.14,25.21-1.55,2.51-3.33,4.87-5.3,7.04-.52,.58-1.06,1.15-1.62,1.7-8.69,8.68-20.69,14.06-33.95,14.06-17.27,0-32.4-9.12-40.86-22.8-4.53-7.33-7.15-15.96-7.15-25.21s2.74-18.29,7.47-25.73c1.89-2.98,4.1-5.73,6.59-8.22,8.69-8.69,20.7-14.06,33.95-14.06s25.26,5.37,33.95,14.06c2.48,2.48,4.69,5.24,6.59,8.22,1.42,2.23,2.66,4.58,3.7,7.04,2.42,5.75,3.77,12.06,3.77,18.69Z'/%3e%3cpath class='cls-7' d='M605.4,658.01h0c-19.33,0-34.66-16.31-33.47-35.6l7.84-126.55c.84-13.54,12.06-24.09,25.63-24.09h0c13.56,0,24.79,10.55,25.63,24.09l7.84,126.55c1.2,19.3-14.13,35.6-33.47,35.6Z'/%3e%3c/g%3e%3c/g%3e%3cg%3e%3ccircle class='cls-9' cx='378.48' cy='845.45' r='28.44'/%3e%3ccircle class='cls-9' cx='491.94' cy='845.45' r='28.44'/%3e%3ccircle class='cls-9' cx='605.39' cy='845.45' r='28.44'/%3e%3ccircle class='cls-9' cx='718.85' cy='845.45' r='28.44'/%3e%3ccircle class='cls-9' cx='832.31' cy='845.45' r='28.44'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e",
    },
    changePassword: {
      //ResetPasswordForm
      headingText: '',

      //Password Changed
      buttonText: 'Close',
      confirmHeadingText: '',
      subText: '',
      image: '',
    },
    changeWalletPasscode: {
      wordCount: 12,
      heading: `${BRAND_NAME} Wallet Recovery Phrase`,
      subHeading: 'Please enter your 12 word recovery phrase below.',
      subText:
        `Please create a wallet passcode. This will be used to access and perform transactions on your ${BRAND_NAME} Wallet`,
      warningText: 'Do not make your wallet passcode the same as your account',
      matchesText: 'Passcode Matches',
      strengthText: 'Passcode strength:',
      buttonText: 'Reset Passcode',

      //Confirm Modal
      confirmText: 'Your Wallet Passcode is successfully changed',
      confirmButtonText: 'Close',
      confirmImage: confirmCircleCheck.src,
    },
    dashboard: {
      walletCoins: [brandCoin, 'USDC', 'ETH', 'BTC'],
      //Table Defaults
      table: {
        icons: {
          headingSortDescendingIcon: downArrow.src,
          headingSortAscendingIcon: upArrow.src,
          paginationLeftIcon: leftArrow.src,
          paginationRightIcon: rightArrow.src,
        },
        rowsPerPage: [25, 50, 75, 100],
        statusIcons: {
          greenDot: greenDot, //minted reward  or transaction complete
          redDot: redDot, //not minted reward
          orangeDot: orangeDot, //transaction pending
        },
        sortAscending: true,
      },
      //Dashboard Wallet Info
      walletVault: {
        titleText: `My ${BRAND_NAME} Wallet`,
        buttonText: 'Set Up Wallet',
      },

      //DashboardNodes Info
      nodeSetupInfo: {
        downloadSystemOneLink: ' https://static.setpowerfree.com/softnode/green_mac.dmg',
        downloadSystemTwoLink: 'https://static.setpowerfree.com/softnode/green_win.exe',
        downloadSystemThreeLink:
          'https://static.setpowerfree.com/softnode/green_linux.AppImage',
        systemOneIcon: appleLogo.src,
        systemTwoIcon: windowsLogo.src,
        systemThreeIcon: linuxLogo.src,
        downloadSystemOneText: 'Download for Mac OS',
        downloadSystemTwoText: 'Download for Windows',
        downloadSystemThreeText: 'Download for Linux',
        instructions:
          'https://core-sdk-dev-public-temp.s3.us-west-2.amazonaws.com/docs/node-set-up-instructions-basic.pdf',
      },
      downloadHelpDocument:
        'https://core-sdk-dev-public-temp.s3.us-west-2.amazonaws.com/docs/node-set-up-instructions-basic.pdf',
      userNodeInfo: {
        activeNodes: {
          headingText: 'Total Nodes',
          nodeDataOne: 0,
        },
        smartNodes: {
          headingText: 'Total Smart Nodes',
          nodeDataOne: 0,
        },
        liteNodes: {
          headingText: 'Total Lite Nodes',
          nodeDataOne: 0,
        },
      },
      nodesVault: {
        titleText: `My ${BRAND_NAME} Nodes`,
        buttonOneText: 'Purchase Nodes',
        buttonTwoText: 'Set Up Nodes',
      },

      //Dashboard MyVault Rewards info
      userRewardsInfo: {
        recentReward: {
          headingText: 'Most Recent Reward',
          nodeDataOne: 0,
        },
        availableReward: {
          headingText: 'Rewards Available to Mint',
          nodeDataOne: 0,
        },
        totalReward: {
          headingText: 'Total Rewards Earned',
          nodeDataOne: 0,
        },
      },
      rewardsVault: {
        titleText: `My ${BRAND_NAME} Vault`,
        buttonOneText: 'Mint Rewards',
        buttonTwoText: 'View Rewards History',
      },
      mintRewardsImage: mintRewardsImage.src,
      rewardStatusText: {
        minted: 'Minted',
        notMinted: 'Not Minted',
        tableHeading:`${BRAND_NAME} Rewards`,
        mobileTableHeading: 'Rewards',
        //Table column headings for mint rewards table
        colName: 'Name',
        colAmount: 'Amount',
        colEarned: 'Earned Date',
        colStatus: 'Status',
        colMinted: 'Minted Date & Time',
      },

      //WalletFunctionality (send, receive, view coin transactions)
      tabLabels: ['Send', 'Receive', 'Transaction History'],
      mobileTabLabels: ['Send', 'Receive', 'TX History'],

      //Send Transaction Confirmation
      sendConfirmImage: sendConfirmationImg.src,
      sendHeadingText: 'Transfer Complete',
      sendButtonText: 'Return to Dashboard',
      sendBodyText:
        'Your transaction has been sent, please verify and check status from your dashboard.',
    },
    rewards: {
      headingText: `My ${BRAND_NAME} Rewards`,
      totalPoints: {
        headingText: 'Total Points',
        units: 'Points',
        actionText: 'Earn More Points',
        tooltipText:
          'This represents the total amount of points you have earned in the Nerd ecosystem',
        modal: {
          headingText: 'Earn More Points',
          bodyText:
            'Provide examples of how your customers can earn more points. For example, purchasing and running more nodes.',
          buttonText: 'Close',
        },
      },
      latestReward: {
        headingText: 'Last Rewards Distribution',
        units: `${brandCoin}`,
        actionText: 'Reward Calculation Details',
        tooltipText:
          `This represents the number of ${brandCoin} coins you earned with the most recent distribution. Distribution usually happens once a day`,
        modal: {
          headingText: 'How Rewards are Determined',
          bodyText:
            'Provide an example of how Users’ points are summed up and divided by all Users’ points and then multiply their share against fixed number of rewards distributed that day.',
          buttonText: 'Close',
        },
      },
      totalRewards: {
        headingText: `My Total ${BRAND_NAME} Earned`,
        units: `${brandCoin}`,
        actionText: 'Transfer to ETH Network',
        tooltipText:
          `This represents the number of ${BRAND_NAME} coins you have earned all time in the ${BRAND_NAME} ecosystem`,
        modal: {
          headingText: 'Transfer to ETH Network',
          bodyText:
            `Transfer your ${brandCoin} Rewards to the Ethereum network to create an ERC-20 ${BRAND_NAME} token. This feature is coming soon.`,
          buttonText: 'Close',
        },
      },
    },
    emailCheck: {
      brandImage: brandIcon.src,
      headingText: 'We need to verify your email address.',
      bodyText: '',
      image: verifyImage.src,
      buttonText: '',
      sentMessageText: '',
    },
    emailConfirmation: {
      //need design for this page
    },
    manageAccount: {
      tabs: {
        defaultTab: 'Profile',
        tab1: 'Profile',
        tab2: 'Reset Password',
        tab3: 'Change Passcode',
        tab4: 'Two Factor Auth',
      },
      profile: {
        heading: 'Profile',
        firstName: 'First Name*',
        lastName: 'Last Name*',
        email: 'Email Address *',
        phone: 'Phone Number',
        phoneTooltipNo2FA:
          'If you wish to enable Two-Factor Authentication only enter a number capable of receiving text messages.',
        phoneTooltipWith2FA:
          'To update your phone number, please disable two factor authentication first.',
        dob: 'Date of Birth',
        dobMonths: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        timeZone: 'Time Zone',
        editButton: 'Edit',
        backButton: 'Back',
        updateButton: 'Update',
        successMessage: 'Your Profile is Successfully Updated',
        modalCloseButtonText: 'Close',
        phoneToolTipText: 'To update your phone number, please disable your 2FA first.',
      },
      resetPassword: {
        heading: 'Reset Password',
        passwordLabel: 'New Password',
        passwordPlaceholder: 'Enter new password',
        passwordSubtext: 'Password must have:',
        confirmPasswordLabel: 'Confirm Password',
        confirmPlaceholder: 'Confirm password',
        confirmError: "Password doesn't match",
        confirmValid: 'Password matches',
        continueButton: 'Reset',
        confirmModal: {
          buttonText: 'Close',
          confirmHeadingText: 'Your Password is Successfully Changed',
          subText: '',
          image: confirmCircleCheck.src,
        },
      },
      mfa: {
        modal: {
          title: 'Setup Two-Factor Authentication',
          subText: (
            <>
              <p>Two-Factor Authentication is now available!</p>
              <p>
                {`Security is critical at ${brandName}. To help keep your account safe, we
                will text you a verification code when you sign in. You can set this up at any time in your settings.`}
              </p>
            </>
          ),
          cancelButtonText: 'Cancel',
          continueButtonText: 'Get Started',
        },
        landing: {
          headingTextDisabled: 'Two-Factor Authentication Is Disabled.',
          headingTextEnabled: 'Two-Factor Authentication Is Enabled',
          headingSubtextDisabled:
            'Two-factor authentication adds an extra layer of security to your account by asking for a verification code when you sign in.',
          headingSubtextEnabled:
            'Before you disable 2FA, please consider why you enabled it. Without 2FA, hackers are only one password guess away from gaining access to your account.',
          disabledCards: [
            {
              id: 1,
              imageSource: mfaImage1.src,
              bodyText: 'Log in using your email and password as usual.',
            },
            {
              id: 2,
              imageSource: mfaImage2.src,
              bodyText:
                'Using a two-factor authentication process, receive a passcode to verify your identity.',
            },
            {
              id: 3,
              imageSource: mfaImage3.src,
              bodyText: `Once you enter the passcode at the prompt, you’ll be logged onto our web console.`,
            },
          ],
          enabledCards: [
            {
              id: 1,
              imageSource: mfaImage1.src,
              bodyText:
                'If someone tries to hack into your account, you will know about it immediately.',
            },
            {
              id: 2,
              imageSource: mfaImage2.src,
              bodyText:
                'Putting in place two-factor authentication (2FA) can be a crucial part of meeting industry regulations.',
            },
            {
              id: 3,
              imageSource: mfaImage3.src,
              bodyText:
                '2FA safeguards against password fatigue by ensuring cybercriminals cannot hack simple passwords',
            },
          ],
          buttonTextDisabled: 'Setup Two-factor Authentication',
          buttonTextEnabled: 'Disable Two-factor Authentication',
        },
        setupMFA: {
          imageSource: mfaImageEnable.src,
          continueButtonText: 'Continue',
          cancelButtonText: 'Cancel',
          //enter user password
          passwordProgressLabel: 'Password',
          passwordHeaderText: 'Two-Factor Authentication Setup.',
          passwordHeaderTag: 'mfaTitleTextPassword', //these are the data tags for each component
          passwordSubText: 'To continue, please enter your password.',
          passwordSubTag: 'mafSubTextPassword',
          //enter phone number
          phoneProgressLabel: 'Phone',
          phoneHeaderText: 'Let’s Setup Your Phone!',
          phoneHeaderTag: 'mfaTitleTextPassword',
          phoneSubText:
            'We’ll text a verification code to this mobile number whenever you sign in to your account.',
          phoneSubTag: 'mfaSubTextPhone',
          phoneLabelText: 'Phone Number',
          phoneInputSubText: `${brandName} will use this number for account security only.`,
          //enter verification code
          codeProgressLabel: 'Code',
          codeHeaderText: 'Confirm That it Works!',
          codeHeaderTag: 'mfaTitleTextCode',
          codeSubText: 'Enter the authentication code below we sent to ', //phone number populated by page component
          codeSubTag: 'mfaSubTextCode',
          codeResendText1: 'Retry sending new code in ', //text before timer count down
          codeResendText2: ' seconds.', //text after timer count down
          //confirmation success
          confirmHeaderText: 'It Worked!',
          confirmHeaderTag: 'mfaTitleTextConfirm',
          confirmSubText1: 'Your phone number is set to ',
          confirmSubTag1: 'mfaSubTextConfirm1',
          confirmSubText2:
            'Authentication codes will be texted to this number for logging in.',
          confirmSubTag2: 'mfaSubTextConfirm2',
          confirmButtonText: 'Done',
          confirmButtonTag: 'mfaButtonConfirm',
        },
        disableMFA: {
          imageSource: mfaImageDisable.src,
          //enter user password
          passwordHeaderText: 'Disable Two-Factor Authentication.',
          passwordHeaderTag: 'mfaTitleTextPassword',
          passwordSubText: 'To continue, please enter your password.',
          passwordSubTag: 'mafSubTextPassword',
          //enter phone number
          phoneHeaderText: 'Disable Two-Factor Authentication.',
          phoneHeaderTag: 'mfaTitleTextPassword',
          phoneSubText: 'We’ll text a verification code to this mobile number.',
          phoneSubTag: 'mfaSubTextPhone',
          //enter verification code
          codeHeaderText: 'Disable Two-Factor Authentication.',
          codeHeaderTag: 'mfaTitleTextCode',
          codeSubText: 'Enter the authentication code below. ',
          codeSubTag: 'mfaSubTextCode',
          codeSubText2: 'This will disable Two-Factor authentication entirely.',
          codeSubTag2: 'mfaSubTextCode',
          confirmSubText: '',
          confirmSubTag: '',
          //confirmation success
          confirmHeaderText: 'Two-Factor Authentication Disabled.',
          confirmHeaderTag: 'mfaTitleTextConfirm',
          confirmSubText1: '',
          confirmSubTag1: 'mfaSubTextConfirm1',
          confirmSubText2: '',
          confirmSubTag2: 'mfaSubTextConfirm2',
          confirmButtonText: 'Done',
          confirmButtonTag: 'mfaButtonConfirm',
        },
        verifyPassword: {
          labelText: 'Confirm Password',
          cancelButtonText: 'Cancel',
          continueButtonText: 'Continue',
        },
        verifyCode: {
          resendCodeText: 'Resend Code',
        },
        errorMessages: {
          requiredMessage: 'This field is required.',
          invalidPassword: 'Invalid Password, please try again.',
          invalidPhone: 'This phone number is invalid. Please try another phone number.',
          genericPhone: 'We are unable to complete this request. Please try again.',
          invalidCode: 'Wrong SMS code. Try again.',
          expiredCode: 'Your code has expired, please request a new one.',
          disableCode:
            'This account is already enabled in 2FA, please unenroll and try again.',
          duplicatePhone:
            'The provided phone number is already in use by an existing user. Each user must have a unique phone number.',
          tooManyTries:
            'Your account has been temporarily disabled due to too many attempts. Please try again later.',
        },
      },
    },
    purchase: {
      shoppingFormText: {
        //Top right side Order Summary
        orderHeadingText: '',
        orderCartEmptyText: '',
        //Left side Purchase Nodes
        productHeadingText: '',
        productHeadingTooltipText:
          'You can purchase 10 smart nodes at a time. You can also purchase 999 lite nodes at a time.',
        //Bottom Right Side Payment Options
        paymentHeadingText: '',
        paymentLoadingText: '',
        paymentLowFundsText: '',
        paymentAddETHText: '',
        paymentSetupWalletText: '',
        paymentLoginText: '',
        paymentButtonText: '',
        paymentOptionButtonSubText: '',
        productNoticeText:
          'Currently our system supports orders of only one node type at a time. Please select either Smart Nodes (up to 10 quantity) or Lite Nodes (up to 999 quantity). If you would like to purchase both node types, simply complete an order for one and then return to complete an order for the next node type. If you need to select the other node type, lower quantity to 0 for your current node selection and the other node type will become available to select quantity.',
        shoppingMobileToolTip: 'You can scroll vertically to view your order.',
      },
      //Add ETH Modal
      headerText: 'Add More Funds To Your Wallet',
      bodyText:
        `Send Ethereum to your ${BRAND_NAME} Wallet by either scanning the QR code or simply copying and pasting this wallet address into the send to/recipient address of a compatible wallet application.  After successfully sending, please click done below and refresh the purchase page every few minutes until you see your funds appear.  This usually takes 5-10 minutes, although it could take longer if the network is busy.`,
      bodySubText:
        `As a reminder, Smart Node prices increase as more are sold. Given the fact that Ethereum's price and gas fees are volatile, we recommend transferring at least 10% more than you anticipate needing to complete your purchase.  Any remaining Ethereum in your ${BRAND_NAME} Wallet after making a purchase can be used to mint your node's digital rewards into ${BRAND_NAME} coins on the Ethereum Blockchain.`,
    },
    checkoutProcess: {
      steps: [
        { label: 'Lock In Price' },
        { label: 'Review Order' },
        { label: 'Submit Order' },
        { label: 'Process Order' },
        { label: 'Confirmation' },
      ],
      //Lock in price
      lockInPriceImgSrc: imageLockInPrice.src,
      lockInPriceTitleText: 'Lock In Price',
      lockInPriceBodyText: 'Please wait a moment while we lock in your final price.',
      //Review Order
      reviewOrderTitleText: 'Review Order',
      reviewOrderBodyText:
        'We have now locked in the prices of your selected nodes! You have 10 minutes to review and submit your order.',
      reviewOrderContinueButtonText: 'Continue',
      reviewOrderCancelOrderButtonText: 'Cancel Order',
      reviewOrderInfoIconText:
        'Review your order below. If you do not complete these steps in time, this order will be cancelled and you will be required to lock in pricing again, at which time the node prices may have increased. As a reminder, Smart Node prices increase by $100 for every 100 sold.',
      //Submit Order
      submitOrderImgSrc: imageSubmitOrder.src,
      submitOrderFormText: {
        titleText: '',
        bodyText: '',
        toolTip: '',
        submitButton: '',
        cancelButton: '',
      },
      //Process Order
      processOrderImageSource: imageProcessOrder.src,
      processOrderText: {
        titleText: '',
        bodyText: '',
        bodySubText: '',
        buttonText: '',
        goToDashboardButtonText: '',
      },
      //Confirmation
      confirmationText: {
        header: '',
        message: '',
        dashboardTaskHeader: '',
        downloadIconSrc: '',
        downloadText: '',
        rewardsIconSrc: '',
        manageRewardsText: '',
        buttonText: '',
      },
      orderSummaryText: {
        dateHeading: '',
        paymentHeading: '',
        walletHeading: '',
        orderHeading: '',
        txnHashHeading: '',
        etherscanHeading: '',
        etherscanLink: '',
      },
      productSummaryText: {
        descriptionHeading: '',
        quantityHeading: '',
        currencyHeading: '',
        coinHeading: '',
        feeDesc: '',
        denomination: '',
        coin: '',
      },
      //Timer Ended
      timerEndedCancelModalBodyText:
        'Your order was not submitted in time and has been cancelled. You are being returned to the Purchase page where you can begin to place another order',
      timerEndedCancelModalButtonText: 'Return to Purchase Page',
      timerEndedCancelModalTitleText: 'Your order has been cancelled',
    },
    setupWallet: {
      createWalletSuccessText:
        `Your ${BRAND_NAME} Wallet is now set up! You can now send, receive, and hold token balances.`,
      createWalletFailText:
        'Sorry, there was an issue trying to create your wallet. Please try again.',
      resultModalButtonText: 'Go To Dashboard',
      processingText:
        `Please wait, this page will refresh when your ${BRAND_NAME} Wallet is set up.`,
      processingImage: setupProcessingImg.src,
      createPasscodeHeader: 'Create A Wallet Passcode',
      createPasscodeSubHeader:
        `Please create a wallet passcode. This will be used to access and perform transactions with your ${BRAND_NAME} wallet.`,
      stepIcons: {
        uncompletedStepIcon: undefined,
        currentStepIcon: undefined,
        completedStepIcon: undefined,
      },
      discoveryPhraseText: {
        headingText: `My ${BRAND_NAME} Wallet Recovery Phrase`,
        areYouSureText:
          'Are you sure you secured your wallet recovery phrase in at least two locations?',
        areYouSureContinueButtonText: "Yes, I'm Sure",
        areYouSureReturnButtonText: 'No, Show Me Again',
        buttonText: 'I Secured My Recovery Phrase',
        bodyText: (
          <>
            This is the only time you will be shown your wallet recovery phrase. Write
            down and save the following{' '}
            <span className="body body--emphasis">twelve lowercase words</span> in the{' '}
            <span className="body body--emphasis">exact order</span> they appear below, in
            a safe location. Should you forget your private key, you will be asked to
            enter the following phrase to recover access to your {brandName} Wallet. If
            you cannot remember your wallet recovery phrase after forgetting your private
            keys, {brandName} does not have the ability to access your wallet and all of
            your funds will be lost.
          </>
        ),
      },
      confirmRecoveryPhraseText: {
        headerText: `Confirm ${BRAND_NAME} Wallet Recovery Phrase`,
        subText:
          'To be certain you have the correct recovery phrase, please enter the twelve lowercase words in order.',
        buttonOneText: 'Complete',
        buttonTwoText: 'Return To Wallet Recovery Phrase',
      },
    },
    errorPages: {
      serverFailed: {
        title: '500 Internal server error.',
        subText: 'We are unable to complete this request. Please try again later.',
        notRecordedImage: serverErrorImage.src,
      },
      pageNotFound: {
        title: '404 page not found.',
        subText: "Ah, the dreaded 404. Let's get you back on track.",
        buttonText: 'Try again',
        urlRedirect: '/nodes',
        image: pageNotFoundImage.src,
      },
      infoPageOffline: {
        title: 'You are currently offline.',
        subText: 'Please check your internet connection and try again.',
        image: pageNotFoundImage.src,
      },
    },
    voting: {
      charterKey: "GIVE_TEST_1",
    },
  },
};